import React from 'react';
import { motion } from 'framer-motion';

const Manifesto = () => {
    const principles = [
        { number: "01", title: "Los Datos No Mienten", text: "Todo diagnóstico, propuesta y evaluación estará fundamentado en evidencia cuantificable y verificable. Sin excusas, sin relatos." },
        { number: "02", title: "El Código Postal No Es Destino", text: "Creemos que nacer en Pantitlán no debería limitar tu futuro. La tecnología y la organización pueden romper ciclos de pobreza." },
        { number: "03", title: "Transparencia Radical", text: "Cada peso rastreado. Cada decisión documentada. Cada resultado publicado. La opacidad es el enemigo." },
        { number: "04", title: "La Comunidad Es La Red", text: "No esperamos salvadores. Construimos nodos humanos que se apoyan mutuamente. Si uno cae, la red lo levanta." },
        { number: "05", title: "Experimentar, Medir, Iterar", text: "Preferimos 10 pilotos fallidos con aprendizaje que una promesa vacía. La ciencia exige prueba y error." },
    ];

    return (
        <section id="manifesto" className="py-32 bg-background relative overflow-hidden">
            {/* Decorative Grid */}
            <div className="absolute inset-0 opacity-5">
                <div
                    className="w-full h-full"
                    style={{
                        backgroundImage: 'linear-gradient(to right, #00FF41 1px, transparent 1px), linear-gradient(to bottom, #00FF41 1px, transparent 1px)',
                        backgroundSize: '60px 60px'
                    }}
                ></div>
            </div>

            <div className="container mx-auto px-6 relative z-10">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7 }}
                    className="text-center mb-20"
                >
                    <span className="text-primary font-mono text-sm tracking-widest uppercase mb-4 block">DECLARARACIÓN DE PRINCIPIOS</span>
                    <h2 className="text-5xl md:text-7xl font-display font-black text-white mb-6 tracking-tighter">
                        MANIFIESTO<span className="text-primary">.</span>
                    </h2>
                    <p className="text-xl text-zinc-500 max-w-2xl mx-auto">
                        Estas son las reglas inquebrantables bajo las cuales opera el Instituto i³. No son sujetas a negociación.
                    </p>
                </motion.div>

                <div className="space-y-8 max-w-4xl mx-auto">
                    {principles.map((item, index) => (
                        <motion.div
                            key={item.number}
                            initial={{ opacity: 0, x: index % 2 === 0 ? -30 : 30 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.5, delay: index * 0.1 }}
                            className="group flex items-start gap-6 p-6 bg-surface/50 backdrop-blur border border-zinc-800 hover:border-primary/50 rounded-xl transition-all duration-300"
                        >
                            <span className="font-mono text-4xl font-bold text-primary/30 group-hover:text-primary transition-colors">
                                {item.number}
                            </span>
                            <div>
                                <h3 className="text-xl font-bold text-white mb-2 group-hover:text-primary transition-colors">
                                    {item.title}
                                </h3>
                                <p className="text-zinc-400 leading-relaxed">
                                    {item.text}
                                </p>
                            </div>
                        </motion.div>
                    ))}
                </div>

                {/* Signature */}
                <motion.div
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7, delay: 0.5 }}
                    className="mt-20 text-center"
                >
                    <p className="text-zinc-600 font-mono text-sm mb-4">Firmado digitalmente por</p>
                    <p className="font-display text-2xl text-white font-bold">Pablo Martínez</p>
                    <p className="text-primary font-mono text-sm">Director General · Instituto i³</p>
                    <p className="text-zinc-700 font-mono text-xs mt-2">Pantitlán, Iztacalco · Diciembre 2025</p>
                </motion.div>
            </div>
        </section>
    );
};

export default Manifesto;
